import UserSettingsView from './views/UserSettingsView.vue';
import SyncView from './views/SyncView';
import StartView from './views/StartView';
import VastuualueAsetuksetView from "@/views/VastuualueAsetuksetView";
import StrategiaView from "@/views/StrategiaView";
import ValintaAsetuksetView from "@/views/ValintaAsetuksetView";
import ValintatyyppiAsetuksetView from "@/views/ValintatyyppiAsetuksetView";
import ValintaEditView from "@/views/ValintaEditView";
import VastuualueView from "@/views/VastuualueView";
import TehtavatView from "@/views/TehtavatView";
import HenkilotView from "./views/HenkilotView";
import HenkiloView from "./views/HenkiloView";
import TehtavaEditView from "@/views/TehtavaEditView";
import LoggedOutView from "@/views/LoggedOutView.vue";


export default [
  {
    path: '/',
    name: 'start',
    component: StartView,
  },
  {
    path: '/settings',
    name: 'settings',
    component: UserSettingsView,
  },
  {
    path: '/sync',
    name: 'sync',
    component: SyncView,
  },
  {
    path: '/asetukset/vastuualue',
    name: 'asetukset_vastuualue',
    component: VastuualueAsetuksetView
  },
  {
    path: '/asetukset/valinta',
    name: 'asetukset_valinta',
    component: ValintaAsetuksetView
  },
  {
    path: '/asetukset/valinta/uusi',
    name: 'asetukset_valinta_uusi',
    component: ValintaEditView
  },
  {
    path: '/asetukset/valinta/:id',
    name: 'asetukset_valinta_muokkaus',
    component: ValintaEditView
  },
  {
    path: '/asetukset/valintatyyppi',
    name: 'asetukset_valintatyyppi',
    component: ValintatyyppiAsetuksetView
  },
  {
    path: '/asetukset/henkilot',
    name: 'asetukset_henkilot',
    component: HenkilotView
  },
  {
    path: '/asetukset/henkilo',
    name: 'omat_tiedot',
    component: HenkiloView
  },
  {
    path: '/vastuualue/:id/:vuosi?',
    name: 'vastuualue',
    component: VastuualueView
  },
  {
    path: '/tehtavat/t/uusi',
    name: 'tehtava_uusi',
    component: TehtavaEditView
  },
  {
    path: '/tehtavat/t/:tehtavaId',
    name: 'tehtava_muokkaus',
    component: TehtavaEditView
  },
  {
    path: '/tehtavat/:vuosi/:vastuualueId/:valintaId',
    name: 'tehtavat_vuosi_vastuualue_valinta',
    component: TehtavatView
  },
  {
    path: '/tehtavat/:vuosi/:vastuualueId',
    name: 'tehtavat_vuosi_vastuualue',
    component: TehtavatView
  },

  {
    path: '/strategia',
    name: 'strategia',
    component: StrategiaView,
  },
  {
    path: '/loggedout',
    name: 'logged_out',
    component: LoggedOutView,
  },
  {path: '*', redirect: '/'},
];
